const $ = jQuery;

const Template = new class {
    constructor() {
        $( () => this.onDocumentReady() );
    }

    onDocumentReady() {
        this.initHeader();
        this.initbodyScroll();
        this.initMisc();
        this.initAccordion();
        this.initLinkIcons();
    }

    initHeader() {

        $('.main-nav li:has(ul)').addClass('has-children')
        .children('a')
        .on('click', function (e) {

            let p = $(this).parent();

            // close navigation in case of a second click on same main navigation item on desktop viewport
            if(p.hasClass('selected') && p.parent().parent().hasClass('main-nav') && !$('.toggle-btn-burger').is(':visible')) {
                toggleNavigation();
                e.preventDefault();
                return;
            }

            // reset and set li.selected on current ul
            p.siblings().removeClass('selected');
            p.addClass('selected');

            // set active class to child ul
            p.children('ul').addClass('active');

            // reset active class to siblings ul
            p.siblings().find('ul').removeClass('rootline active').find('li').removeClass('selected');

            // remove active class from current ul and set rootline class on current ul
            $(this).closest('ul').removeClass('active').addClass('rootline');

            // toggle Navigation on desktop viewport if not already done
            if (!$('html').hasClass('nav-main-open') && !$('.toggle-btn-burger').is(':visible')) {
                toggleNavigation();
            }

            e.preventDefault();
        });

        // return to previous level navigation
        $('.main-nav ul ul').prepend('<li class="level-back"><button class="main-nav-btn-back"></button></li>');
        
        $('.main-nav .main-nav-btn-back').click(function (e) {
            let p = $(this).parent();
            // remove active class from current ul
            $(this).closest('ul').removeClass('active');

            // remove rootline class from parent ul
            // set active class to parent ul
            // remove selected class from all parent ul li
            $(this).closest('ul.rootline')
                .removeClass('rootline')
                .addClass('active')
                .children('li').removeClass('selected');

            e.preventDefault();
        });

        // open / close navigation on mobile viewport
        $('.toggle-btn-burger').click(function (e) {
            toggleNavigation();
            e.preventDefault();
        });

        // close navigation on esc key
        $(document).on('keydown', function(event) {
            if (event.key == "Escape") {
                if ($('html').hasClass('nav-main-open')) {
                    toggleNavigation();
                }
            }
        });

        // close navigation on click on #menu-overlay in desktop viewport
        $('#menu-overlay').on('click', function (e) {
            if (
                $('html').hasClass('nav-main-open') && 
                !$('.toggle-btn-burger').is(':visible')
            ) {
                toggleNavigation();
                e.preventDefault();
            }
    });

        // close  navigation on resize
        let toggleBtnIsVisible = false;
        $(window).resize(function () {

            if (toggleBtnIsVisible != $('.toggle-btn-burger').is(':visible')) {
                if ($('html').hasClass('nav-main-open')) {
                    toggleNavigation();
                }
            }

            toggleBtnIsVisible = $('.toggle-btn-burger').is(':visible');

        });

        const toggleNavigation = function () {

            // toggle class to show / hide navigation
            $('html').toggleClass('nav-main-open');

            // navigation is open
            // set root level navigation to active
            if ($('html').hasClass('nav-main-open')) {
                $('.main-nav > ul').addClass('active');
            }

            // navigation is closed
            // remove dynamic classes in case navigation has been closed
            if (!$('html').hasClass('nav-main-open')) {
                $('.main-nav ul').removeClass('active rootline');
                $('.main-nav li').removeClass('selected');
            }

        };

        // remove dynamic classes on reload just for safety reasons (history back)
        $(window).on('unload', function () {
            $('html').removeClass('nav-main-open');
            $('.main-nav ul').removeClass('active rootline');
            $('.main-nav li').removeClass('selected');
        });

    }

    initbodyScroll() {

        let lastScr = 0;

        $(window).scroll(function () {
            let scr = $(window).scrollTop();
            let headerHeight = $('#header').outerHeight();
            $('html').toggleClass('sticky', scr >= headerHeight);
            $('html').toggleClass('scrolling-up', (scr < lastScr));
            $('html').toggleClass('scrolling-down', scr > lastScr);
            lastScr = scr;
        }).scroll();

    }

    initMisc() {

        $('.history-back').click(function (e) {
            e.preventDefault();
            history.back();
        });

        $(window).on('scroll resize', function () {
            let w = $(window),
                d = $(document),
                h = $('html'),
                scrolledToEnd = (w.scrollTop() + w.height()) >= d.height();

            $('.footer-top-btn').toggleClass('active', $(window).scrollTop() > $(window).height());

            h.toggleClass('scrolled-to-end', scrolledToEnd);
        });

        $('.footer-top-btn').click((e) => {
			e.preventDefault();
			$('body, html').animate( { scrollTop: 0 }, 300 );
		});

    }

    initAccordion() {

        $('.accordion .accordion-headline').append('<span class="accordion-toggle-btn"></span>');

        $('.accordion .accordion-headline').click(function (e) {
            e.preventDefault();
            let elem = $(this).closest('.accordion-panel');
            elem.siblings('.open').addBack().toggleClass('open').children('.accordion-content').slideToggle(200, function () {
                let p = $(this).closest('.accordion-panel');
            });

        });

    }

    initLinkIcons () {
        // append svgs to buttons and links
        $('.cta-download').append('<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"><path d="M13.936 8A5.935 5.935 0 018 13.935 5.935 5.935 0 012.065 8 1.033 1.033 0 000 8a8 8 0 008 8 8 8 0 008-8 1.033 1.033 0 00-2.064 0zm-6.968-.17L5.633 6.495a1.033 1.033 0 00-1.46 1.461l3.097 3.097.038.036.04.034.042.032.042.03.044.027.044.025.023.011.01.005.012.006.019.009.014.006.014.005.014.005.019.008.013.004.01.005.025.008.049.013.014.003a1.003 1.003 0 00.487 0l.015-.003.049-.013.024-.008.01-.005.014-.004.019-.008.014-.005.014-.005.014-.006.019-.009.012-.006.01-.005.023-.011.044-.025.044-.027.042-.03.041-.032.04-.034.039-.036 3.097-3.097a1.033 1.033 0 00-1.46-1.46L9.032 7.83V1.033a1.033 1.033 0 00-2.064 0V7.83z" fill="#000"/></svg>');
        $('.job-teaser-link, .arrow-link, .cta-primary-back, .cta-secondary-back, .cta-primary-back-large, .cta-secondary-back-large, .cta-primary-next, .cta-secondary-next, .cta-primary-next-large, .cta-secondary-next-large').append('<svg viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"><path d="M16.554 10.315a1.132 1.132 0 000-1.592l-5.625-5.625a1.13 1.13 0 00-.753-.288 1.127 1.127 0 00-.838 1.88l3.709 3.706H2.261a1.13 1.13 0 00-1.125 1.125 1.13 1.13 0 001.125 1.125h10.785L9.34 14.351a1.128 1.128 0 00-.305.771c0 .618.509 1.127 1.127 1.127.286 0 .562-.109.771-.305l5.625-5.625-.004-.004z" fill-rule="nonzero"/></svg>');
        $('.link-phone').append('<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"><path d="M7.845 11.855a9.654 9.654 0 01-3.526-3.403l1.735-2.079c.271-.347.392-.53.463-.725.079-.218.112-.45.097-.682-.014-.207-.08-.416-.244-.825l-.474-1.185c-.238-.595-.387-.878-.592-1.074l-.001-.001a1.665 1.665 0 00-.838-.429l-.002-.001c-.279-.052-.595-.007-1.218.149l-1.312.328a.665.665 0 00-.504.645c0 7.058 4.94 11.998 11.998 11.998a.665.665 0 00.645-.503l.328-1.311c.156-.625.201-.941.149-1.22l-.001-.002a1.665 1.665 0 00-.429-.838c-.195-.205-.477-.354-1.075-.593l-1.057-.423c-.463-.186-.699-.258-.933-.266h-.001a1.667 1.667 0 00-.755.155l-.001.001c-.209.098-.399.258-.75.609l-1.702 1.675zm1.28.606c1.148.451 2.419.717 3.785.77l.2-.796c.084-.338.159-.502.131-.653a.338.338 0 00-.086-.169c-.106-.111-.282-.145-.605-.275l-1.058-.423c-.244-.098-.359-.166-.482-.17a.332.332 0 00-.149.03c-.111.052-.19.162-.377.348l-1.359 1.338zM3.659 7.168l1.348-1.615c.14-.179.223-.26.26-.361a.336.336 0 00.02-.137l-.001-.003c-.006-.106-.066-.206-.15-.417L4.662 3.45c-.13-.322-.165-.499-.275-.605a.342.342 0 00-.169-.086c-.151-.028-.314.047-.651.131l-.798.2c.058 1.484.366 2.855.89 4.078z" fill="#131a29"/></svg>');
        $('.link-mobile').append('<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"><path d="M9.865 14.665h-3.73c-.83 0-1.28 0-1.71-.22-.38-.19-.68-.49-.87-.87-.22-.43-.22-.88-.22-1.71v-7.73c0-.83 0-1.28.22-1.71.19-.38.5-.68.87-.87.43-.22.88-.22 1.71-.22h3.73c.83 0 1.28 0 1.71.22.38.19.68.49.87.87.22.43.22.88.22 1.71v7.73c0 .83 0 1.28-.22 1.71-.2.38-.5.68-.88.88-.42.22-.88.22-1.71.22l.01-.01zm-3.73-12c-.58 0-.96 0-1.1.07-.13.06-.23.17-.29.29-.07.14-.07.52-.07 1.1v7.73c0 .58 0 .96.07 1.1.06.12.17.23.29.29.15.08.53.08 1.1.08h3.73c.58 0 .96 0 1.1-.07.13-.07.23-.17.29-.29.07-.14.07-.52.07-1.1v-7.73c0-.58 0-.96-.07-1.1a.627.627 0 00-.29-.29c-.14-.07-.53-.07-1.1-.07h-3.73v-.01zm1.87 10a.67.67 0 01-.67-.67c0-.37.29-.67.66-.67a.67.67 0 010 1.34h.01z" fill="#131a29" fill-rule="nonzero"/></svg>');
        $('.link-fax').append('<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"><path d="M4.664 2.773a1.989 1.989 0 00-1.331-.512 2.008 2.008 0 00-1.998 1.998v8c0 1.096.902 1.998 1.998 1.998.513 0 .98-.193 1.334-.51.128.115.271.213.426.292v.001c.348.176.797.217 1.707.217h5.067c.909 0 1.359-.041 1.707-.217v-.001c.376-.191.682-.497.873-.873h.001c.176-.348.217-.798.217-1.707v-6.4c0-.909-.04-1.359-.217-1.707v-.001a1.996 1.996 0 00-.874-.872c-.347-.178-.798-.219-1.707-.219H6.8c-.91 0-1.36.041-1.707.219a1.954 1.954 0 00-.429.294zm.668 9.497a.665.665 0 00.365.584c.223.114.518.073 1.103.073h5.067c.584 0 .88.041 1.103-.073a.665.665 0 00.292-.292c.114-.223.073-.519.073-1.103v-6.4c0-.585.04-.881-.073-1.105a.668.668 0 00-.291-.29l-.002-.001c-.223-.114-.519-.073-1.102-.073H6.8c-.584 0-.879-.041-1.102.073l-.002.001a.668.668 0 00-.291.29.767.767 0 00-.073.296v8.02zm-1.999.657a.672.672 0 01-.668-.668v-8c0-.367.302-.668.668-.668.367 0 .669.301.669.668v8c0 .369-.3.668-.669.668zM12 10.26h-1.333a.665.665 0 000 1.33H12a.665.665 0 000-1.33zm-2.668-.335c0-.913-.752-1.665-1.665-1.665s-1.665.752-1.665 1.665.752 1.665 1.665 1.665 1.665-.752 1.665-1.665zm-1.33 0a.336.336 0 01-.335.335.336.336 0 01-.335-.335c0-.184.151-.335.335-.335.184 0 .335.151.335.335zM12 8.26h-1.333a.665.665 0 000 1.33H12a.665.665 0 000-1.33zm0-3.333H6.667a.665.665 0 000 1.33H12a.665.665 0 000-1.33z" fill="#131a29"/></svg>');
        $('.link-email').append('<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"><path d="M5.201 12.259c-.571 0-.96-.001-1.26-.025-.292-.024-.441-.068-.546-.121l-.605 1.188c.324.165.668.231 1.043.262.367.029.819.029 1.368.029v-1.333zm-1.806-.146a1.32 1.32 0 01-.582-.582l-1.188.605c.255.502.663.91 1.165 1.165l.605-1.188zM1.334 6.792v2.933c0 .549-.001 1.001.029 1.368.031.375.097.719.262 1.043l1.188-.605c-.053-.105-.097-.254-.121-.546a14.699 14.699 0 01-.025-1.054V6.826l2.619 1.75.001.001c.811.539 1.352.91 1.956 1.055l.31-1.297c-.318-.076-.63-.272-1.526-.867L2.726 5.263a1.02 1.02 0 01.087-.276c.127-.251.331-.455.582-.583l.01-.005c.104-.051.253-.092.536-.115.3-.025.689-.025 1.26-.025h5.6V2.925h-5.6c-.549 0-1.001 0-1.368.03-.375.03-.719.096-1.043.261-.502.256-.91.664-1.165 1.165-.165.324-.231.668-.262 1.043-.03.367-.029.819-.029 1.368zm13.031 5.367l.012-.023c.164-.324.23-.668.261-1.043.026-.321.029-.707.029-1.167V6.792h-1.242 1.242c0-.402.001-.753-.011-1.055a.64.64 0 00-.02-.337c-.032-.366-.099-.702-.259-1.019a2.673 2.673 0 00-1.166-1.165l-.328.643.328-.643c-.323-.165-.668-.231-1.042-.261-.367-.03-.819-.03-1.368-.03v1.334c.571 0 .959 0 1.259.025.292.024.442.067.546.12l.01-.019-.01.019c.251.128.455.332.583.583.036.07.067.16.09.3l-3.269 2.18c-.896.596-1.208.792-1.527.868a2.002 2.002 0 01-.93 0l-.31 1.297c.51.122 1.041.122 1.55 0l.028-.007c.594-.15 1.131-.517 1.928-1.048l-.369-.555.37.555 2.584-1.724v2.872c0 .571 0 .96-.025 1.26-.023.283-.064.432-.115.536l-.005.01a1.328 1.328 0 01-.56.57l-.023.012c-.104.053-.254.097-.546.121-.3.024-.688.025-1.259.025h-5.6v1.333h5.6c.549 0 1.001 0 1.368-.029.374-.031.719-.097 1.042-.262.494-.251.897-.65 1.154-1.142z" fill="#131a29" fill-rule="nonzero"/></svg>');
    }

}();